import { isArray } from 'lodash';
import {
  LOCAL_STORAGE_TIEOUT_APP_IDENTIFIER,
  TIME_TO_LIVE_FOR_LOCALE_LANGUAGE_JSON,
} from 'constants/common/feature-common-utils';
import { getAllContainerDetails } from 'api/project-list-api';
import { getAllCountriesListFromLocalstorage } from '../../utils/project-utils';

/**it checks localStorage key "tieout__AllCountriesList" with its value if it exists
 * it won't be triggers /tieout/containers/all API call to fetch all the countries list(static data) and
 * if localStorage key not present it will creates key with value of response of /tieout/containers/all API call.
 * Note: this localStorage key will be updated based on the expiry value
 */
export const fetchAndUpdateAllCountriesList = () => async () => {
  const countriesList = getAllCountriesListFromLocalstorage();
  if (
    // if allCountryList does not exist or it has expired for specific locale then only we want to make api call.
    !(
      countriesList &&
      isArray(countriesList.data) &&
      countriesList.data.length > 0 &&
      countriesList.expiry > new Date().getTime()
    )
  ) {
    try {
      const response = await getAllContainerDetails();
      // append time to live with allCountriesList
      const countriesListWithTTL = response &&
        response.data && {
          data: response.data,
          expiry: new Date().getTime() + TIME_TO_LIVE_FOR_LOCALE_LANGUAGE_JSON,
        };

      localStorage.setItem(
        `${LOCAL_STORAGE_TIEOUT_APP_IDENTIFIER}_AllCountriesList`,
        JSON.stringify(countriesListWithTTL),
      );
    } catch (e) {
      console.error(e);
    }
  }
};
